import axios from 'axios';
import { httpApi } from './http';
import type {
  ExpenseAdminDetailParams,
  ExpenseAdminDetailResponse,
  ExpensesAdminListParams,
  ExpensesAdminListResponse,
} from '../types/expense';

const api = httpApi;

export class ExpenseService {
  static async listLatestExpensesAdmin(params: ExpensesAdminListParams = {}): Promise<ExpensesAdminListResponse> {
    try {
      const response = await api.get<ExpensesAdminListResponse>('/expense/admin', {
        params: {
          page: params.page ?? 1,
          limit: params.limit ?? 25,
          q: params.q ?? '',
          sortBy: params.sortBy ?? 'created',
          sortOrder: params.sortOrder ?? 'desc',
        },
      });

      if (!response.data) throw new Error('No data received from server');
      if (!response.data.success) {
        throw new Error(response.data.error || response.data.message || 'API request failed');
      }
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const apiError = (error.response?.data as any)?.error || (error.response?.data as any)?.message;
        if (apiError) throw new Error(apiError);
        if (status) throw new Error(`Server error: ${status}`);
        if (error.request) throw new Error('Network error: Unable to connect to server');
      }
      throw new Error('Failed to fetch expenses');
    }
  }

  static async getExpenseDetailAdmin(userId: string, params: ExpenseAdminDetailParams = {}): Promise<ExpenseAdminDetailResponse> {
    try {
      const response = await api.get<ExpenseAdminDetailResponse>(`/expense/admin/user/${encodeURIComponent(userId)}`, {
        params: params.version ? { version: params.version } : undefined,
      });

      if (!response.data) throw new Error('No data received from server');
      if (!response.data.success) {
        throw new Error((response.data as any).error || (response.data as any).message || 'API request failed');
      }
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        const apiError = (error.response?.data as any)?.error || (error.response?.data as any)?.message;
        if (apiError) throw new Error(apiError);
        if (status) throw new Error(`Server error: ${status}`);
        if (error.request) throw new Error('Network error: Unable to connect to server');
      }
      throw new Error('Failed to fetch expense detail');
    }
  }
}
